import { FC } from 'react';

export const TipCell: FC<any> = ({ children }) => {
  return <div className="tip-container__td">{children}</div>;
};
